/**
 * @module パスワードロック確認表示用コンポーネント
 */
import EmailMessenger from '@/components/emailMessenger/EmailMessenger.vue';
import ThanksPageTitle from './ThanksPageTitle.vue';
import NativeCallback from '../../../api/nativeCallback';
import ExternalUrl from '../../../api/externalLinks/externalUrls';

export default {
  name: 'ThanksPasswordLockConfirmation',
  components: {
    EmailMessenger,
    ThanksPageTitle,
  },
  data() {
    return {};
  },
  props: {},
  /** @type {Methods} */
  methods: {
    /**
     * 通話アプリでコール
     */
    call() {
      //通話アプリでコールではなくて、リンクを表示するだけに変更 #27117
      window.open(ExternalUrl.alsokInquiry, '_blank');
    },
    /**
     * ログイン画面へ遷移
     */
    goLogin() {
      this.$router.replace({ path: '/login' });
    },
  },
  computed: {
    nativeError() {
      return this.$store.getters['appInfo/getNativeError'].errorCode;
    },
  },
  watch: {
    nativeError(newVal) {
      if (NativeCallback.codeInclude(newVal, '10-E0002')) {
        // 電話アプリ起動失敗時
        this.$errorDialog(
          '$vuetify.メッセージ一覧.FECU54Thanks画面.E0001'
          // "アプリの起動に失敗しました。もう一度「ALSOK営業までご連絡ください。」を押してください。",
        );
      }
      this.$store.commit('appInfo/setNativeError', { errorCode: '' });
    },
  },
};
